/*
 * Memo / Floraïku — Gift samples (Function-backed)
 * Lit les règles (métaobjets memo_sample_rule, rendues dans window.MemoGiftConfig),
 * ajoute les samples au panier en les TAGUANT "_memo_gift" ; la Function
 * "Free gift samples" met à 0 € toute ligne taguée (cumul illimité, 1 seul discount).
 *
 * Types de règle :
 *  - auto_sample   : chaque EDP -> son sample 1.5ml si dispo dans la collection des samples ;
 *                    exclut les EDP des collections "exclude".
 *  - cart_subtotal : panier >= min -> giftVariant ; sauf si le panier contient un produit des collections "exclude".
 *  - product       : produit/variante présent -> giftVariant.
 *
 * Extraction du code parfum (EDP <-> sample) paramétrée par CFG.skuScheme :
 *  - "memo"     (défaut) : EDP = {edpSkuPrefix}{format}{CODE} ; sample = {sampleSkuPrefix}{CODE}.
 *  - "floraiku"          : EDP = FK[ligne?]{format}{CODE} (code = lettres finales) ;
 *                          sample = FK{ligne}ECH{CODE} (code = après "ECH").
 */
(function () {
  "use strict";

  var CFG = window.MemoGiftConfig;
  if (!CFG) return;
  var RULES = Array.isArray(CFG.rules) ? CFG.rules.filter(Boolean) : [];
  if (!RULES.length) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var PROP = CFG.propertyKey || "_memo_gift";

  // Offres conditionnées par un lien : on capte ?freegifts_code=CODE à l'arrivée et on le
  // mémorise (localStorage) pour qu'il s'applique sur tout le parcours. Une règle avec
  // "required_link_code" ne s'active QUE si ce code correspond.
  var LINK_PARAM = CFG.linkParam || "freegifts_code";
  var STORE_KEY = "memo_gift_link_code";
  var linkCode = "";
  try {
    var lm = (window.location.search || "").match(new RegExp("[?&]" + LINK_PARAM + "=([^&#]+)", "i"));
    if (lm) { linkCode = decodeURIComponent(lm[1]).trim().toLowerCase(); window.localStorage.setItem(STORE_KEY, linkCode); }
    else { linkCode = (window.localStorage.getItem(STORE_KEY) || "").toLowerCase(); }
  } catch (e) { linkCode = ""; }
  var SCHEME = CFG.skuScheme || "memo";
  var EDP = CFG.edpSkuPrefix || "MMEDP";
  var SAMPLE = CFG.sampleSkuPrefix || "MMECH1";
  var FORMAT_RE = new RegExp("^" + esc(EDP) + "\\d+K?", "i");
  // stripVersionSuffix : retire un suffixe de version (V2, V3…) en fin de code pour matcher
  // EDP <-> sample même quand l'un porte "V2" et pas l'autre (ex. Hermetica HEDP…V2 / HECH…).
  var STRIPV = CFG.stripVersionSuffix;
  function stripVer(c) { return (STRIPV && c) ? c.replace(/V\d+$/i, "") : c; }

  var syncing = false, pending = false, timer = null;
  var sampleIndex = null;   // CODE -> { variantId }
  var collIndex = {};       // handle -> { productId: true }
  var scentCache = {};      // productId(string) -> variantId(number) | null  (sample de la senteur, via Storefront API)
  var scentReady = false;   // true dès qu'un appel Storefront a réussi (sinon on garde le fallback SKU)

  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }
  function url(p) { return (root.replace(/\/$/, "") || "") + p; }
  function getCart() { return fetch(url("/cart.js"), {headers: {Accept: "application/json"}}).then(function (r) { return r.json(); }); }
  function isGift(i) { if (!i || !i.properties) return false; var v = i.properties[PROP]; return v != null && v !== "" && v !== "0" && v !== "false"; }

  // Code parfum à partir d'un SKU de SAMPLE (selon le schéma de la boutique).
  function sampleCode(sku) {
    if (!sku) return null;
    var u = String(sku).toUpperCase();
    var c;
    if (SCHEME === "floraiku") {
      var i = u.lastIndexOf("ECH");
      if (i === -1) return null;
      c = u.slice(i + 3);
    } else {
      if (u.indexOf(SAMPLE.toUpperCase()) !== 0) return null;
      c = u.slice(SAMPLE.length);
    }
    return stripVer(c) || null;
  }

  // Code parfum à partir d'un SKU d'EDP (selon le schéma de la boutique).
  function edpCode(sku) {
    if (!sku) return null;
    var u = String(sku).toUpperCase();
    if (SCHEME === "floraiku") {
      if (u.indexOf("ECH") !== -1) return null;     // c'est un sample, pas un EDP
      var m = u.match(/\d([A-Z]+)$/);               // FK[ligne?]{format}{CODE} -> lettres finales
      return m ? stripVer(m[1]) || null : null;
    }
    if (u.indexOf(EDP.toUpperCase()) !== 0) return null;
    var c = sku.replace(FORMAT_RE, "").toUpperCase();
    return stripVer(c) || null;
  }

  // AUTORITÉ product_scent (Storefront API) : pour chaque produit du panier, on lit
  // product_scent.sample_variant et on l'impose (override total du SKU). Nécessite un jeton
  // Storefront (paramètre de thème). Sans jeton / si l'appel échoue -> scentReady reste false
  // et l'engine retombe sur le SKU-matching (aucune régression). Résultat caché par produit.
  function loadScentSamples(productIds) {
    var token = CFG.storefrontToken;
    if (!token) return Promise.resolve();
    var need = [];
    (productIds || []).forEach(function (p) { if (p != null && !(String(p) in scentCache)) need.push(p); });
    if (!need.length) return Promise.resolve();
    var ver = CFG.storefrontApiVersion || "2024-10";
    var q = "query($ids:[ID!]!){nodes(ids:$ids){... on Product{id m:metafield(namespace:\"custom\",key:\"product_scent\"){reference{... on Metaobject{f:field(key:\"sample_variant\"){reference{... on ProductVariant{id availableForSale}}}}}}}}}";
    var gids = need.map(function (p) { return "gid://shopify/Product/" + p; });
    return fetch(url("/api/" + ver + "/graphql.json"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json", "X-Shopify-Storefront-Access-Token": token},
      body: JSON.stringify({query: q, variables: {ids: gids}}),
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.errors || !d.data || !d.data.nodes) return; // échec/token invalide -> on ne cache rien -> fallback SKU
        scentReady = true;
        need.forEach(function (p) { scentCache[String(p)] = null; }); // défaut : senteur sans sample -> aucun cadeau
        d.data.nodes.forEach(function (n) {
          if (!n || !n.id) return;
          var pid = toVariantId(n.id);
          var sv = n.m && n.m.reference && n.m.reference.f && n.m.reference.f.reference;
          if (sv && sv.id && sv.availableForSale !== false) scentCache[String(pid)] = toVariantId(sv.id);
          else scentCache[String(pid)] = null;
        });
      })
      .catch(function () { /* réseau KO -> on ne cache rien -> retry au prochain tour, fallback SKU entre-temps */ });
  }

  // Accepte un ID numérique OU un GID Shopify ("gid://shopify/ProductVariant/123")
  // et renvoie l'ID numérique attendu par /cart/add.js. Les vouchers par devise
  // (gift_by_currency, métaobjet json) sont stockés en GID -> il FAUT extraire le nombre.
  function toVariantId(v) {
    if (v === null || v === undefined) return null;
    var m = String(v).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : null;
  }

  // sampleAvail : connaissance de la dispo des variantes de la collection samples.
  // { known: {variantId:true}, avail: {variantId:true} }. Permet de NE JAMAIS offrir
  // un sample en rupture. Pour une variante inconnue (ex. voucher hors samples-to-try)
  // on suppose dispo (best effort) -> pas de régression sur les vouchers.
  var sampleAvail = null;
  function offerable(v) {
    var id = toVariantId(v);
    if (!id) return false;
    if (sampleAvail && sampleAvail.known[id]) return !!sampleAvail.avail[id];
    return true;
  }

  // Liste des variantes cadeaux d'une regle pour la devise courante. Priorite :
  //  1) gift_by_currency[devise] : string = 1 variante, ou tableau = plusieurs ;
  //  2) gift_variants (liste multi-produits) -> offre TOUS ces produits ;
  //  3) gift_variant (variante unique historique).
  function resolveGiftVariants(rule, currency) {
    var gbc = rule.giftByCurrency;
    if (typeof gbc === "string") { try { gbc = JSON.parse(gbc); } catch (e) { gbc = null; } }
    var cur = gbc && gbc[currency];
    if (cur != null && cur !== "") return Array.isArray(cur) ? cur.slice() : [cur];
    if (Array.isArray(rule.giftVariantIds) && rule.giftVariantIds.length) return rule.giftVariantIds.slice();
    if (rule.giftVariantId) return [rule.giftVariantId];
    return [];
  }

  function loadSamples() {
    if (sampleIndex) return Promise.resolve(sampleIndex);
    if (!CFG.samplesCollection) { sampleIndex = {}; sampleAvail = {known: {}, avail: {}}; return Promise.resolve(sampleIndex); }
    return fetch(url("/collections/" + CFG.samplesCollection + "/products.json?limit=250"), {headers: {Accept: "application/json"}})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var idx = {}, known = {}, avail = {};
        (d.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            var c = sampleCode(v.sku);
            if (!c) return;
            known[v.id] = true;
            if (v.available !== false) avail[v.id] = true;
            if (v.available === false) return; // idx = samples DISPONIBLES uniquement
            idx[c] = {variantId: v.id};
          });
        });
        sampleIndex = idx; sampleAvail = {known: known, avail: avail}; return idx;
      })
      .catch(function () { sampleIndex = {}; sampleAvail = {known: {}, avail: {}}; return sampleIndex; });
  }

  function loadColl(handle) {
    if (collIndex[handle]) return Promise.resolve(collIndex[handle]);
    return fetch(url("/collections/" + handle + "/products.json?limit=250"), {headers: {Accept: "application/json"}})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var s = {};
        (d.products || []).forEach(function (p) { s[String(p.id)] = true; });
        collIndex[handle] = s; return s;
      })
      .catch(function () { collIndex[handle] = {}; return collIndex[handle]; });
  }

  function preloadCollections() {
    var handles = {};
    RULES.forEach(function (r) {
      (r.excludeCollectionHandles || []).forEach(function (h) { if (h) handles[h] = true; });
      (r.triggerCollectionHandles || []).forEach(function (h) { if (h) handles[h] = true; });
    });
    return Promise.all(Object.keys(handles).map(loadColl));
  }

  function merchSubtotal(cart) {
    return (cart.items || []).reduce(function (s, i) { return isGift(i) ? s : s + (i.final_line_price || 0); }, 0);
  }

  // ----- Seuil (min_subtotal) : CONVERSION PAR DEVISE -----
  // Le seuil des regles est saisi dans la devise de la BOUTIQUE, alors que le panier
  // (final_line_price de /cart.js) est libelle dans la devise ACTIVE du marche. Sans conversion, un
  // seuil de "30" valait 30 dans n'importe quelle devise : sur les marches a devise faible l'offre
  // devenait sans plancher reel. On convertit donc le seuil avec le taux expose par Shopify
  // (Shopify.currency.rate = taux devise boutique -> devise active ; 1.0 quand les deux coincident).
  // Taux absent ou invalide -> 1, soit le comportement historique (aucune regression).
  function currencyRate() {
    var c = window.Shopify && window.Shopify.currency;
    var r = c ? parseFloat(c.rate) : NaN;
    if (!r || !isFinite(r) || r <= 0) return 1;
    return r;
  }
  function ruleMinCents(rule) {
    var m = rule.minSubtotalCents;
    if (!m || m <= 0) return 0;
    return Math.round(m * currencyRate());
  }

  // ----- Filtre par NOM DE VARIANTE (champ de regle trigger_variant_names) -----
  // Un article ne compte comme declencheur que si le nom de sa variante correspond a l'une des
  // valeurs listees (ex. "75ML", "Refill"). Comparaison tolerante : casse, espaces et ponctuation
  // ignores, correspondance PARTIELLE ("75ml" matche "75 ML / Coffret"). On regarde le titre de la
  // variante ET chaque valeur d'option (un produit mono-variante n'a pas de variant_title utile).
  // Liste vide = aucun filtre (comportement historique).
  // normTokens : "75ML" / "75 ml" / "75-ML" -> ["75","ml"]. On coupe aussi entre chiffres et
  // lettres, et on neutralise les accents, pour que la saisie du marchand n'ait pas a etre exacte.
  function normTokens(s) {
    var t = String(s == null ? "" : s).toLowerCase();
    if (t.normalize) t = t.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return t
      .replace(/([0-9])([a-z])/g, "$1 $2")
      .replace(/([a-z])([0-9])/g, "$1 $2")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
      .split(" ")
      .filter(Boolean);
  }
  // Le nom cherche doit apparaitre comme suite COMPLETE de mots : "5 ml" ne matche donc PAS
  // ["75","ml"] (sinon toute regle "5ML" attraperait les 75ML/35ML), alors que "refill" matche
  // bien ["75","ml","refill"].
  function tokensContain(hay, needle) {
    if (!needle.length || needle.length > hay.length) return false;
    for (var i = 0; i + needle.length <= hay.length; i++) {
      var ok = true;
      for (var j = 0; j < needle.length; j++) { if (hay[i + j] !== needle[j]) { ok = false; break; } }
      if (ok) return true;
    }
    return false;
  }
  function variantHaystack(item) {
    var parts = [item.variant_title];
    if (Array.isArray(item.variant_options)) parts = parts.concat(item.variant_options);
    (item.options_with_values || []).forEach(function (o) { if (o) parts.push(o.value); });
    var out = [];
    parts.forEach(function (p) { var t = normTokens(p); if (t.length) out.push(t); });
    return out;
  }
  function matchesVariantNames(item, names) {
    if (!names || !names.length) return true;   // vide = toutes les variantes
    var hay = variantHaystack(item);
    if (!hay.length) return false;              // regle exigeante + article sans variante nommee
    return names.some(function (n) {
      var q = normTokens(n);
      if (!q.length) return false;
      return hay.some(function (h) { return tokensContain(h, q); });
    });
  }

  function excludedByVariantName(item, names) {
    return !!(names && names.length) && matchesVariantNames(item, names);
  }

  function inCollections(productId, handles) {
    return (handles || []).some(function (h) {
      var set = collIndex[h];
      return set && set[String(productId)];
    });
  }

  function desired(cart, idx) {
    var items = (cart.items || []).filter(function (i) { return !isGift(i); });
    var subtotal = merchSubtotal(cart);
    var currency = cart.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "";
    var out = [], seen = {};
    function push(vId, qty, msg, label) {
      vId = toVariantId(vId); // accepte numérique OU GID
      if (!vId) return;
      var k = String(vId);
      if (seen[k]) return;
      seen[k] = true;
      out.push({variantId: vId, quantity: qty || 1, message: msg, label: label});
    }

    RULES.forEach(function (rule) {
      // Condition de lien : si la règle exige un code, ne s'applique que si le visiteur est
      // arrivé via ?freegifts_code=CE_CODE (mémorisé). Sinon la règle est ignorée.
      // Fenêtre de planification (active_from / active_until) — vide = pas de limite.
      if (rule.activeFrom) { var _af = Date.parse(rule.activeFrom); if (!isNaN(_af) && Date.now() < _af) return; }
      if (rule.activeUntil) { var _au = Date.parse(rule.activeUntil); if (!isNaN(_au) && Date.now() > _au) return; }
      if (rule.requiredLinkCode && String(rule.requiredLinkCode).trim().toLowerCase() !== linkCode) return;
      var excl = rule.excludeCollectionHandles || [];
      var trigProds = rule.triggerProductIds || [];
      var trigCols = rule.triggerCollectionHandles || [];
      var trigVarNames = rule.triggerVariantNames || [];
      var exclVarNames = rule.excludeVariantNames || [];

      if (rule.triggerType === "auto_sample") {
        // Regle inactive seulement si AUCUN ciblage : ni collections, ni noms de variante.
        if (!trigCols.length && !trigVarNames.length) return;
        var scentSampleEx = CFG.scentSampleByProduct || {};
        items.forEach(function (item) {
          if (inCollections(item.product_id, excl)) return;
          if (trigCols.length && !inCollections(item.product_id, trigCols)) return; // FILTRE FORMAT
          if (!matchesVariantNames(item, trigVarNames)) return; // FILTRE NOM DE VARIANTE
          if (excludedByVariantName(item, exclVarNames)) return; // EXCLUSION NOM DE VARIANTE
          var pid = String(item.product_id);
          // 1) AUTORITÉ product_scent via Storefront API : si la senteur du produit a été résolue,
          //    elle DÉCIDE — variante précise, ou AUCUN cadeau si vide/rupture (override total du SKU).
          if (scentReady && (pid in scentCache)) {
            var ssv = scentCache[pid];
            if (ssv && offerable(ssv)) push(ssv, 1, rule.message, rule.giftTag || rule.title);
            return; // autoritaire, y compris "pas de sample"
          }
          // 2) Fallback (pas de jeton Storefront) : sample de senteur exposé via "exclusivities".
          var exsv = scentSampleEx[pid];
          if (exsv && offerable(exsv)) { push(exsv, 1, rule.message, rule.giftTag || rule.title); return; }
          // 3) Fallback : match auto par code SKU. idx = samples dispo.
          var code = edpCode(item.sku);
          if (!code) return;
          var aliasMap = CFG.sampleCodeAliases || {};
          var s = idx[code] || (aliasMap[code] ? idx[aliasMap[code]] : null);
          if (s) push(s.variantId, 1, rule.message, rule.giftTag || rule.title);
        });
        return;
      }

      // Règles "trigger" (produits/collections) et/ou seuil.
      var hasTriggers = trigProds.length || trigCols.length || trigVarNames.length;
      if (!hasTriggers && !(rule.minSubtotalCents > 0)) return;
      var minCents = ruleMinCents(rule);
      if (minCents && subtotal < minCents) return;
      if (items.some(function (item) { return inCollections(item.product_id, excl); })) return;
      // Exclusion par nom de variante sur une regle SANS declencheur (seuil seul) : la presence
      // d'un article exclu au panier annule la regle — meme logique que l'exclusion par collection.
      if (!hasTriggers && items.some(function (item) { return excludedByVariantName(item, exclVarNames); })) return;
      // Ligne declencheuse = matche produits/collections (si renseignes) ET le nom de variante
      // (si renseigne), et n'est pas exclue par nom de variante.
      function isTriggerLine(item) {
        if (excludedByVariantName(item, exclVarNames)) return false;
        if (trigProds.length || trigCols.length) {
          var hit = trigProds.some(function (id) { return String(id) === String(item.product_id); }) || inCollections(item.product_id, trigCols);
          if (!hit) return false;
        }
        return matchesVariantNames(item, trigVarNames);
      }
      var match = !hasTriggers ? true : items.some(isTriggerLine);
      if (match) {
        var qty = rule.giftQuantity || 1;
        // giftPerTrigger : 1 cadeau PAR article déclencheur (ex. 2 Discovery Sets = 2 vouchers).
        if (rule.giftPerTrigger) {
          var units = 0;
          items.forEach(function (item) { if (isTriggerLine(item)) units += (item.quantity || 1); });
          if (units > 0) qty = qty * units;
        }
        // LISTE des cadeaux (multi-produits via gift_variants). qty s'applique a CHAQUE variante.
        var giftList = resolveGiftVariants(rule, currency);
        // backup : uniquement pour le cas variante UNIQUE -> variante de secours si rupture/absente.
        if (giftList.length === 1 && !offerable(giftList[0]) && rule.giftVariantFallbackId) {
          giftList = [rule.giftVariantFallbackId];
        }
        // push() deduplique par variante -> pas de double ajout.
        giftList.forEach(function (gv) { if (offerable(gv)) push(gv, qty, rule.message, rule.giftTag || rule.title); });
      }
    });

    if (CFG.maxGifts && CFG.maxGifts > 0) out = out.slice(0, CFG.maxGifts);
    return out;
  }

  function addGift(g) {
    var p = {};
    p[PROP] = g.label || "1";
    return fetch(url("/cart/add.js"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify({items: [{id: Number(g.variantId), quantity: g.quantity || 1, properties: p}]}),
    }).then(function (r) { if (r.ok && g.message) toast(g.message); return r; });
  }

  // Applique plusieurs changements de quantité en UNE requête (clé de ligne -> quantité,
  // 0 = retrait). Atomique côté Shopify -> les lignes disparaissent ENSEMBLE (un seul re-rendu),
  // au lieu d'appels /cart/change.js parallèles que Shopify sérialise (effet "un par un").
  function updateLines(map) {
    return fetch(url("/cart/update.js"), {
      method: "POST",
      headers: {"Content-Type": "application/json", Accept: "application/json"},
      body: JSON.stringify({updates: map}),
    });
  }

  function reconcile() {
    return getCart().then(function (cart) {
      var pids = (cart.items || []).filter(function (i) { return !isGift(i); }).map(function (i) { return i.product_id; });
      return Promise.all([loadSamples(), preloadCollections(), loadScentSamples(pids)]).then(function (res) {
        var idx = res[0];
        return runReconcile(cart, idx);
      });
    });
  }

  function runReconcile(cart, idx) {
      var want = desired(cart, idx);
      var wantById = {};
      want.forEach(function (g) { wantById[String(g.variantId)] = g; });
      var gifts = (cart.items || []).filter(isGift);
      var presentGift = {}; // variantId -> ligne cadeau présente
      gifts.forEach(function (l) { presentGift[String(l.id)] = l; });
      var anyLine = {};
      (cart.items || []).forEach(function (l) { anyLine[String(l.id)] = true; });

      var updates = {};   // clé de ligne -> quantité (0 = retrait, n = ajustement)
      var adds = [];      // nouveaux cadeaux à ajouter (/cart/add.js, séparément)
      // retirer les cadeaux qui ne sont plus voulus
      gifts.forEach(function (l) { if (!wantById[String(l.id)]) updates[l.key] = 0; });
      // ajouter les cadeaux voulus, ou AJUSTER leur quantité (ex. 1 voucher par Discovery Set)
      want.forEach(function (g) {
        var present = presentGift[String(g.variantId)];
        if (!present) {
          if (!anyLine[String(g.variantId)]) adds.push(g);
        } else if ((present.quantity || 1) !== (g.quantity || 1)) {
          updates[present.key] = g.quantity || 1;
        }
      });
      var hasUpdates = Object.keys(updates).length > 0;
      if (!hasUpdates && !adds.length) return false;
      // TOUS les retraits + ajustements en UNE seule requête (/cart/update.js) -> les cadeaux
      // disparaissent ENSEMBLE (un seul re-rendu), puis les ajouts en séquence.
      return (hasUpdates ? updateLines(updates) : Promise.resolve())
        .then(function () { return adds.reduce(function (p, g) { return p.then(function () { return addGift(g); }); }, Promise.resolve()); })
        .then(function () { return true; });
  }

  function evaluate() {
    if (syncing) { pending = true; return; }
    syncing = true;
    reconcile()
      .then(function (changed) { if (changed) refreshCartUI(); })
      .catch(function (e) { if (window.console) console.warn("[MemoGift]", e); })
      .then(function () { syncing = false; if (pending) { pending = false; schedule(); } });
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(evaluate, 60); }

  function refreshCartUI() {
    if (CFG.cartSectionId) {
      fetch(url("/?sections=" + encodeURIComponent(CFG.cartSectionId)))
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = data[CFG.cartSectionId];
          var el = document.getElementById("shopify-section-" + CFG.cartSectionId);
          if (el && html) el.innerHTML = html;
          dispatchCartEvents();
        })
        .catch(dispatchCartEvents);
      return;
    }
    dispatchCartEvents();
    if (CFG.reloadCartPage && /\/cart(\/|$|\?)/.test(window.location.pathname)) window.location.reload();
  }
  function dispatchCartEvents() {
    ["cart:refresh", "cart:updated", "cart-updated", "ajaxCart:afterCartLoad"].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, {bubbles: true}));
    });
    if (window.Shopify && typeof window.Shopify.onCartUpdate === "function") getCart().then(window.Shopify.onCartUpdate).catch(function () {});
  }

  // ----- Toast cadeau : 100% piloté par les paramètres de thème (CFG.toast) :
  // fond, couleur, tailles desktop/mobile, interlettrage, durée, affichage par appareil.
  // Master on/off = CFG.showToast. Police Futura Passata, sans icône.
  var MOBILE_MQ = "(max-width: 749px)";
  function isMobileView() { return !!(window.matchMedia && window.matchMedia(MOBILE_MQ).matches); }
  var toastStyled = false;
  function ensureToastStyles() {
    if (toastStyled) return;
    toastStyled = true;
    var c = CFG.toast || {};
    var bg = c.bg || "#fff";
    var color = c.color || "#3c3232";
    var ff = c.fontFamily || "'Futura Passata','Futura',sans-serif";
    var fs = c.fontSize > 0 ? c.fontSize : 10;
    var fsM = c.fontSizeMobile > 0 ? c.fontSizeMobile : fs;
    var ls = (c.letterSpacing != null ? c.letterSpacing : 13) / 100; // 13 -> 0.13em
    var css =
      ".memo-gift-toasts{position:fixed;left:50%;bottom:22px;transform:translateX(-50%);z-index:99999;display:flex;flex-direction:column-reverse;align-items:center;gap:7px;pointer-events:none;width:max-content;max-width:92vw;}" +
      ".memo-gift-toast{background:" + bg + ";color:" + color + ";padding:9px 16px;border:1px solid rgba(60,50,50,.10);border-radius:1px;box-shadow:0 4px 14px rgba(60,50,50,.08);font-family:" + ff + ";font-size:" + fs + "px;line-height:1.3;letter-spacing:" + ls + "em;text-transform:uppercase;opacity:0;transform:translateY(8px);transition:opacity .4s ease,transform .4s ease;}" +
      ".memo-gift-toast.is-in{opacity:1;transform:translateY(0);}" +
      "@media " + MOBILE_MQ + "{.memo-gift-toast{font-size:" + fsM + "px;}}";
    var s = document.createElement("style");
    s.setAttribute("data-memo-gift", "");
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }
  var toastsWrap = null;
  function getToastsWrap() {
    if (toastsWrap && document.body && document.body.contains(toastsWrap)) return toastsWrap;
    toastsWrap = document.createElement("div");
    toastsWrap.className = "memo-gift-toasts";
    document.body.appendChild(toastsWrap);
    return toastsWrap;
  }
  function toast(msg) {
    if (CFG.showToast === false || !msg) return;
    var c = CFG.toast || {};
    var mobile = isMobileView();
    if (mobile && c.showMobile === false) return;
    if (!mobile && c.showDesktop === false) return;
    ensureToastStyles();
    var wrap = getToastsWrap();
    var t = document.createElement("div");
    t.className = "memo-gift-toast";
    t.setAttribute("role", "status");
    t.textContent = msg;
    wrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add("is-in"); });
    var dur = c.durationMs > 0 ? c.durationMs : 3000;
    setTimeout(function () {
      t.classList.remove("is-in");
      setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 450);
    }, dur);
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/i;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var u = typeof input === "string" ? input : (input && input.url) || "";
      var p = of.apply(this, arguments);
      if (!syncing && CART_MUTATION.test(u)) p.then(function () { schedule(); }).catch(function () {});
      return p;
    };
  }
  var oo = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { this.__mu = u; return oo.apply(this, arguments); };
  var os = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    if (!syncing && self.__mu && CART_MUTATION.test(self.__mu)) self.addEventListener("load", function () { schedule(); });
    return os.apply(this, arguments);
  };

  // ----- Filets de sécurité -----
  function drawerIsOpen() {
    var d = document.getElementById("cart-drawer");
    if (!d) return false;
    if (d.getAttribute("aria-hidden") === "true") return false; // fermé (cas courant, sans reflow)
    var r = d.getBoundingClientRect();
    return r.width > 1 && r.height > 1;
  }
  var evalQueued = false;
  function queuedDrawerEval() {
    if (evalQueued) return;
    evalQueued = true;
    setTimeout(function () { evalQueued = false; if (drawerIsOpen()) schedule(); }, 50);
  }
  function watchCartDrawer() {
    if (!window.MutationObserver) return;
    var d = document.getElementById("cart-drawer");
    if (!d) { setTimeout(watchCartDrawer, 800); return; } // pas encore dans le DOM
    var rootEl = (d.closest && d.closest(".shopify-section")) || d.parentNode || d;
    new MutationObserver(queuedDrawerEval).observe(rootEl, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ["class", "style", "aria-hidden", "open", "hidden"],
    });
  }
  watchCartDrawer();
  function scheduleBurst() { schedule(); setTimeout(schedule, 700); setTimeout(schedule, 1600); }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.action && /\/cart\/add/i.test(String(f.action))) scheduleBurst();
  }, true);

  setInterval(function () { if (!syncing && drawerIsOpen()) schedule(); }, 1500);

  ["cart:change", "cart-drawer:refreshed"].forEach(function (n) {
    document.addEventListener(n, function () { schedule(); });
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", schedule);
  else schedule();
})();
